import { render, staticRenderFns } from "./approveManage.vue?vue&type=template&id=a7cf10ee&scoped=true&"
import script from "./approveManage.vue?vue&type=script&lang=js&"
export * from "./approveManage.vue?vue&type=script&lang=js&"
import style0 from "./approveManage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./approveManage.vue?vue&type=style&index=1&id=a7cf10ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf10ee",
  null
  
)

export default component.exports